export const GAME_SYSTEM_IDS = {
	ROBOTTA: '1',
	KULT: '2',
	ALIEN: '3',
	DELTA_GREEN: '4',
};

export const GAME_SYSTEM_NAMES = {
	ROBOTTA: 'Robotta',
	KULT: 'Kult',
	ALIEN: 'Alien',
	DELTA_GREEN: 'Delta Green',
};

export const GAME_SYSTEM_OPTIONS = [
	{ id: GAME_SYSTEM_IDS.ROBOTTA, name: GAME_SYSTEM_NAMES.ROBOTTA },
	{ id: GAME_SYSTEM_IDS.KULT, name: GAME_SYSTEM_NAMES.KULT },
	{ id: GAME_SYSTEM_IDS.ALIEN, name: GAME_SYSTEM_NAMES.ALIEN },
	{ id: GAME_SYSTEM_IDS.DELTA_GREEN, name: GAME_SYSTEM_NAMES.DELTA_GREEN },
];

export const isAlienGameSystemType = (gameSystemType) =>
	String(gameSystemType || '') === GAME_SYSTEM_IDS.ALIEN;
export const getAdventureGameSystemType = (adventure) =>
	String(adventure?.type || adventure?.gameSystemId || '');
export const isAlienAdventure = (adventure) =>
	isAlienGameSystemType(getAdventureGameSystemType(adventure));

export const isAlienGameSystemName = (gameSystemName) =>
	String(gameSystemName || '').trim().toLowerCase() === GAME_SYSTEM_NAMES.ALIEN.toLowerCase();

export const isAlienTemplate = (template) =>
	isAlienGameSystemName(template?.gameSystem) || isAlienGameSystemName(template?.name);

export const isAlienCharacter = (character) => isAlienTemplate(character?.template);
